import { render, staticRenderFns } from "./TabInnovationPlan.vue?vue&type=template&id=1ff2b0d1&scoped=true"
import script from "./TabInnovationPlan.vue?vue&type=script&lang=js"
export * from "./TabInnovationPlan.vue?vue&type=script&lang=js"
import style0 from "./TabInnovationPlan.vue?vue&type=style&index=0&id=1ff2b0d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff2b0d1",
  null
  
)

export default component.exports